import { Link } from "react-router-dom";
import posts from "../data/posts";
import PageHeader from "../components/pageHeader";
import { useTranslation } from "../../../i18n/useTranslation";

const formatDate = (iso) => new Date(iso).toLocaleDateString("en-US", { year: "numeric", month: "long", day: "numeric" });

const Insights = () => {
  const { t } = useTranslation();
  const h = t("deviceworks.pageHeaders.insights");
  const sorted = [...posts].sort((a, b) => new Date(b.date) - new Date(a.date));
  return (
    <div>
      <PageHeader eyebrow={h.eyebrow} title={h.title} />
      <div className="max-w-4xl mx-auto px-5 py-16 grid grid-cols-1 gap-5">
        {sorted.map((p) => (
          <Link key={p.slug} to={`/solutions/deviceworks/insights/${p.slug}`} className="dw-card block">
            <div className="dw-mono text-xs" style={{ color: "var(--dw-text-faint)" }}>{formatDate(p.date)}</div>
            <h3 className="pt-2">{p.title}</h3>
            <p className="dw-mini pt-2 text-sm">{p.excerpt}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Insights;
